import { render } from "./OngoingComplianceForm.vue?vue&type=template&id=2aca5eaa&scoped=true"
import script from "./OngoingComplianceForm.vue?vue&type=script&lang=js"
export * from "./OngoingComplianceForm.vue?vue&type=script&lang=js"

import "./OngoingComplianceForm.vue?vue&type=style&index=0&id=2aca5eaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aca5eaa"]])

export default __exports__